import React, { Component } from "react";
import Loader from '../../images/loading-gif.gif'

class PaymentSuccessModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    onCancelClick() {
        window.location.pathname = '/home';
    }

    render() {
        return (
            <>
                <div className='row manual-container-qr border-0 '>
                    <div className='col-12 col-sm-4 col-md-3'>&nbsp;</div>
                    <div className='col-12 col-sm-4 col-md-6'>
                        <div className='payment-details-box-m py-5 mt-5'>
                            <div className='inputboxpay-m mb-2 text-center'>
                                <div className="inputboxpayw-m">
                                    {!!this?.props?.xoroPeSeconds ?
                                        <>
                                            <div className='text-center'>
                                                <img src={Loader} alt='loader' className="loading-image"/>
                                            </div>
                                            <div className='text-center font-18 font-bold mt-3'>Payment Processing</div>
                                            <div className="transaction-text mt-2 text-center">
                                                {`Please wait for ${this?.props?.xoroPeSeconds} Seconds`}
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className='text-center font-18 font-bold mt-3'>Payment Processing</div>
                                            <div className='mt-2'>Your payment will be proceed after checking with bank.</div>
                                            <div>If not received, Contact support executive.</div>
                                            <div className='mt-3'>Thank you for your convenience!</div>
                                            <button className='btn btn-danger mt-3' onClick={() => this.onCancelClick()}>Home</button>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12 col-sm-4 col-md-3'>&nbsp;</div>
                </div>
            </>
        )
    }
}

export default PaymentSuccessModal